import { EmbedForWebSettings } from "../../views/EmbedForWeb/EmbedForWebSettings";

export function EmbedForWeb() {
    return (
        <>
            <EmbedForWebSettings />
        </>
    );
}
